import { render, staticRenderFns } from "./UserEmployeeInvite.vue?vue&type=template&id=6d3822e7&scoped=true&"
import script from "./UserEmployeeInvite.vue?vue&type=script&lang=js&"
export * from "./UserEmployeeInvite.vue?vue&type=script&lang=js&"
import style0 from "./UserEmployeeInvite.vue?vue&type=style&index=0&id=6d3822e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3822e7",
  null
  
)

export default component.exports